/* ===================================================================
   THE FLOAT CLUB — fc-clarity.js
   Microsoft Clarity analytics slot.

   CLARITY_ID is deliberately empty. With no id set this file returns
   before the official loader below ever runs — no beacon, no script
   tag, no console error. It is a provably inert placeholder, not a
   stub that silently fails.

   To go live: paste the project id (Clarity dashboard -> Settings ->
   Setup -> Install tag -> the 10-ish character id in the snippet) into
   CLARITY_ID below. Nothing else in this file needs to change.
=================================================================== */
var CLARITY_ID = "";
if (CLARITY_ID) {
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);
}
